module.exports = __webpack_public_path__ + "static/img/用户列表@2x.2cb408a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/用户列表@2x.png
// module id = TXrs
// module chunks = 1